export default "__VITE_ASSET__BpQOWo4e__"